import React from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import '../../../../assets/css/seller/subscreens/termsConditions/TermsConditions.css';
import SellerMasterLayout from '../../../../layouts/seller/SellerMasterLayout';

const TermsConditions = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/seller/settings');
  };

  return (
    <SellerMasterLayout>
      <div className="terms-conditions-page">
        {/* Back Button */}
        <button onClick={handleBack} className="back-to-settings-btn">
          <FiArrowLeft size={18} />
          Back to Settings
        </button>

        {/* Terms Card */}
        <div className="sd-terms-conditions-card">
          <h3 className="sd-terms-page-title">Seller Terms & Conditions</h3>

          <div className="sd-terms-list">
            <div className="sd-terms-point">
              <span className="sd-terms-number">1</span>
              <p className="sd-terms-text">
                <span className="sd-terms-heading">Account Eligibility</span>
                Sellers must be 18 or older and provide accurate shop details.
              </p>
            </div>

            <div className="sd-terms-point">
              <span className="sd-terms-number">2</span>
              <p className="sd-terms-text">
                <span className="sd-terms-heading">Handmade products only</span>
                Only handmade and creative products may be listed on CraftHive.
              </p>
            </div>

            <div className="sd-terms-point">
              <span className="sd-terms-number">3</span>
              <p className="sd-terms-text">
                <span className="sd-terms-heading">Product information</span>
                Listings should have accurate details, genuine images, and match
                the actual product in quality.
              </p>
            </div>

            <div className="sd-terms-point">
              <span className="sd-terms-number">4</span>
              <p className="sd-terms-text">
                <span className="sd-terms-heading">Delivery</span>
                Sellers are responsible for delivering orders on time. A fixed
                charge of Rs. 200 applies per order.
              </p>
            </div>

            <div className="sd-terms-point">
              <span className="sd-terms-number">5</span>
              <p className="sd-terms-text">
                <span className="sd-terms-heading">Cancellations</span>
                Orders can be cancelled before dispatch. CraftHive does not
                offer refunds after dispatch.
              </p>
            </div>

            <div className="sd-terms-point">
              <span className="sd-terms-number">6</span>
              <p className="sd-terms-text">
                <span className="sd-terms-heading">Customization</span>
                Custom order details should be discussed with the customer
                through chat before accepting.
              </p>
            </div>

            <div className="sd-terms-point">
              <span className="sd-terms-number">7</span>
              <p className="sd-terms-text">
                <span className="sd-terms-heading">Commission</span>
                CraftHive deducts a commission per sale. The remaining balance
                is added to the seller's wallet.
              </p>
            </div>

            <div className="sd-terms-point sd-terms-point-last">
              <span className="sd-terms-number">8</span>
              <p className="sd-terms-text">
                <span className="sd-terms-heading">Fair use</span>
                Selling prohibited or unsafe items, or violating these terms,
                may lead to account restriction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </SellerMasterLayout>
  );
};

export default TermsConditions;